module.exports = __webpack_public_path__ + "img/quote-post.3def0471.png";